import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const MasterAdminBaseUrl = `${Base_Url}/auth`;


export const userList = async (params) => {
  let url = `${MasterAdminBaseUrl}/userList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};
export const blogListForWebsite = async (params) => {
  let url = `${MasterAdminBaseUrl}/blogListForWebsite`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const AddUpdateUser = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${MasterAdminBaseUrl}${url}`, params);
    return res;
  };
// export const AddUpdateStateApi = async (url = '', params) => {
//   if (params.stateID === null || params.stateID === undefined) {
//     delete params.stateID;
//   }

//   const res = await postApiWithAuthenticated(`${MasterAdminBaseUrl}${url}`, params);
//   return res;
// };

export const ChangeStateStatus = async (id) => {
  let url = `${MasterAdminBaseUrl}/ChangeBlogStatus?blogKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const getUser = async (id) => {
    let url = `${MasterAdminBaseUrl}/getUser?adminKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const deleteUser = async (id) => {
    let url = `${MasterAdminBaseUrl}/deleteUser?adminKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const changeUserStatus = async (id) => {
    let url = `${MasterAdminBaseUrl}/changeUserStatus?adminKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


// export const GetStateLookupList = async () => {
//     const url = `${MasterAdminBaseUrl}/GetStateLookupList`;
  
//     const res = await getListWithAuthenticated(url );
//     return res;
//   };
  
//   export const ChangeStateStatus = async (id,UserKeyID) => {
//     let url = `${MasterAdminBaseUrl}/ChangeStateStatus?StateID=${id}&UserKeyID=${UserKeyID}`;
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };